/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreelancerComplianceStatus = {
    Compliant: 'COMPLIANT',
    Pending: 'PENDING',
    NotCompliant: 'NOT_COMPLIANT'
} as const;
export type FreelancerComplianceStatus = typeof FreelancerComplianceStatus[keyof typeof FreelancerComplianceStatus];


export function instanceOfFreelancerComplianceStatus(value: any): boolean {
    for (const key in FreelancerComplianceStatus) {
        if (Object.prototype.hasOwnProperty.call(FreelancerComplianceStatus, key)) {
            // @ts-ignore
            if (FreelancerComplianceStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreelancerComplianceStatusFromJSON(json: any): FreelancerComplianceStatus {
    return FreelancerComplianceStatusFromJSONTyped(json, false);
}

export function FreelancerComplianceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerComplianceStatus {
    return json as FreelancerComplianceStatus;
}

export function FreelancerComplianceStatusToJSON(value?: FreelancerComplianceStatus | null): any {
    return value as any;
}

